// removed by extract-text-webpack-plugin
module.exports = {"Switch":"Slider__Switch__3YKIl","Slider":"Slider__Slider__385sk"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/UI/Button/Slider.css
// module id = 888
// module chunks = 2